module.exports = __webpack_public_path__ + "static/media/audia5.1f362ef7.png";